module.exports = __webpack_public_path__ + "static/media/house.39ede612.png";